import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import HomeHeader from '../../../../components/Header/HomeHeader';
import { LandingContainer, OndaEnd, OndaStart, Img } from './styles';
import Message from '../Message';
import Inscriptions from '../Inscriptions';
import { scrollToTopSelector } from '../../selectors';

import ImageWord from '../../../../assets/images/300-hours.png';
import ImageWordEN from '../../../../assets/images/300-hours-EN.png';
import ImageWordSmall from '../../../../assets/images/300-hours-small.png';
import ImageWordSmallEN from '../../../../assets/images/300-hours-small-EN.png';
import { useTranslation } from 'react-i18next';

const Landing = props => {
	const ref = useRef(null);
	const { i18n } = useTranslation();
	const isEnglish = i18n.language === 'en';
	useEffect(() => {
		if (props.scrollToTop) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToTop]);

	return (
		<LandingContainer ref={ref}>
			<OndaStart />
			<OndaEnd />
			<HomeHeader />
			<Inscriptions />
			<Img src={isEnglish ? ImageWordEN : ImageWord} />
			<Img src={isEnglish ? ImageWordSmallEN : ImageWordSmall} onlyMobile={true} />
			<Message />
		</LandingContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToTop: scrollToTopSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
